import {Injectable} from "@angular/core";
import {ListRemote} from "@app/core/lists/domain/list.remote";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ListGroup} from "@app/core/lists/domain/list-group";


const FAVORITES_LIST_ID = -1

@Injectable({
    providedIn: 'root'
})
export class GetFavoritesListCodeUseCase {
    constructor(private listRemote:ListRemote) {
    }

    /**
     * Return the code of the favorites list
     */
    execute(): Observable<number | null> {
        return this.listRemote.getListGroups().pipe(
            map(listGroups => this.findFavoritesListCode(listGroups))
        )
    }

    private findFavoritesListCode(listGroups: ListGroup[]): number | null {
        // Identify the favorites list by its id and retrieve its code,
        // which uniquely identifies the list for fetching detailed information.
        for (const listGroup of listGroups) {
            const foundList = listGroup.lists.find(list => list.id === FAVORITES_LIST_ID)
            if (foundList) {
                return foundList.code;
            }
        }
        return  null;
    }
}


